import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  DOB_NOTES_REFRESH: createSagaAction('DOB_NOTES_REFRESH'),

  DOB_NOTE_CREATE: createSagaAction('DOB_NOTE_CREATE'),
  DOB_NOTE_UPDATE: createSagaAction('DOB_NOTE_UPDATE'),
  DOB_NOTE_DELETE: createSagaAction('DOB_NOTE_DELETE')
}

// Action Creators
export const actions = {
  dobNotesRefresh: ({ jobId }) => ({
    type: constants.DOB_NOTES_REFRESH.ACTION,
    jobId
  }),

  createDobNote: ({ jobId, description, files, userId }) => ({
    type: constants.DOB_NOTE_CREATE.ACTION,
    jobId,
    description,
    files,
    userId
  }),

  updateDobNote: ({ jobId, noteId, userId, description, files }) => ({
    type: constants.DOB_NOTE_UPDATE.ACTION,
    jobId,
    noteId,
    userId,
    description,
    files
  }),

  deleteDobNote: ({ noteId, jobId }) => ({
    type: constants.DOB_NOTE_DELETE.ACTION,
    jobId,
    noteId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.DOB_NOTES_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.DOB_NOTES_REFRESH.SUCCESS:
      return {
        ...state,
        dobNotes: action.payload
      }
    case constants.DOB_NOTES_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.DOB_NOTE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.DOB_NOTE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.DOB_NOTE_DELETE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/dobNoteActions.js